import { ProgressBarProps, Type } from './types';

export const getVariantStrokeColour = (
  variant: ProgressBarProps['variant'],
  type: Type,
) => {
  if (type === Type.Circle && variant === 'error') {
    return `var(--color-red-600)`;
  }
  return `var(--text-status-${variant})`;
};
